<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import AppHeader from './components/AppHeader.vue';
import './fonts/akzidenz-grotesk_next/stylesheet.css';

const store = useStore();
const user = computed(() => store.getters['users/user']);
const showHeader = ref(true);
</script>

<template>
  <div v-if="user" class="relative flex min-h-screen w-full flex-col">
    <app-header v-show="showHeader" id="header"></app-header>
    <main id="main"><router-view class="flex-grow"></router-view></main>
  </div>
  <div v-else class="flex min-h-screen w-full flex-col"><router-view /></div>
</template>

<style lang="postcss">
#app {
  @apply flex h-screen flex-col;
  font-family: 'Akzidenz-Grotesk Next', Avenir, Helvetica, Arial, sans-serif;
  color: #2c3e50;
  min-height: 100vh;
}
</style>

<style scoped lang="postcss">
#header {
  @apply absolute top-0 left-0 z-40 col-span-full w-full border-white shadow;
}

main {
  @apply col-span-10 flex h-screen flex-grow flex-col overflow-y-auto bg-offwhite pt-16;
}
</style>
